export default __webpack_public_path__ + "static/media/Thumb_Facial_Hair_11.1fe6c6cf.png";